import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { CustomValidation } from 'src/app/helpers/customValidation';
import { CommonsealService } from 'src/app/services/commonseal.service';
import { AlertComponent } from 'src/app/structure/alert/alert.component';

@Component({
  selector: 'app-commonseal',
  templateUrl: './commonseal.component.html',
  styleUrls: ['./commonseal.component.css']
})
export class CommonsealComponent implements OnInit {

  editsealData: any;
  editsealId: any;
  // [x: string]: any;
  dateOfResolutionauthorisingtheuseofcommonseal: { month: number; day: number; year: number; };
  dateOfaffixixngsealonthedocument: { month: number; day: number; year: number; };
  commonSealForm: FormGroup;
  ecsList: any = [];
  addBtn: boolean;
  TodayDate: NgbDateStruct;
  disabledOnclick: boolean;

  constructor(private commonSeal: CommonsealService, private activatedRoute: ActivatedRoute, private customValidation: CustomValidation,
    private alert: AlertComponent,private router: Router) { }


  ngOnInit() {
    this.commonSealForm = new FormGroup({
      descriptionOfDocumemts: new FormControl('', [Validators.required, this.customValidation.noWhitespaceValidator]),
      dateOfResolutionauthorisingtheuseofcommonseal: new FormControl('', [Validators.required]),
      dateOfaffixixngsealonthedocument: new FormControl('', []),
      nameOfPerson: new FormControl('', []),
      depositReceiptNumber: new FormControl('', []),
      place: new FormControl('', []),
      remarks: new FormControl('', []),


    })
    this.activatedRoute.params.subscribe(params => {
      if (params['particularId'] != undefined) {
        this.addBtn = true;
        this.editsealId = params['particularId'];
        this.getcommonSealById(this.editsealId);
      } else {
        this.addBtn = false;
      }
    })
    var dateObj = new Date();
    var month = dateObj.getUTCMonth() + 1; //months from 1-12
    var day = dateObj.getUTCDate();
    var year = dateObj.getUTCFullYear();
    this.TodayDate = { year: year, month: month, day: day };
  }
  back(){
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['documentundercommonseallist']  } }],
      { relativeTo: this.activatedRoute.parent });
  }
  setDate(date) {
    if (date != "" && date != null) {
      return date.month + '-' + date.day + '-' + date.year;
    }
    return null;
  }
  setFormatDate(date) {
    if (date != null) {
      return new Date(date);
    }
    return null;
  }

  getcommonSealById(sealId) {
    this.commonSeal.getcommonSealDetailById(sealId).subscribe(response => {
      this.editsealData = response.data[0];
      this.commonSealForm.controls.descriptionOfDocumemts.setValue(this.editsealData.descriptionOfDocumemts);
      this.commonSealForm.controls.nameOfPerson.setValue(this.editsealData.nameOfPerson);
      this.commonSealForm.controls.depositReceiptNumber.setValue(this.editsealData.depositReceiptNumber);
      this.commonSealForm.controls.place.setValue(this.editsealData.place);
      this.commonSealForm.controls.remarks.setValue(this.editsealData.remarks);

      if (this.editsealData.dateOfResolutionauthorisingtheuseofcommonseal != null) {
        let dt = new Date(this.setFormatDate(this.editsealData.dateOfResolutionauthorisingtheuseofcommonseal));
        this.dateOfResolutionauthorisingtheuseofcommonseal = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      }

      if (this.editsealData.dateOfaffixixngsealonthedocument != null) {
        let dt = new Date(this.setFormatDate(this.editsealData.dateOfaffixixngsealonthedocument));
        this.dateOfaffixixngsealonthedocument = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      }
    }
    )
  }
  saveCommonSealData() {
   this.disabledOnclick = true;

    var commonSealObject = {
      descriptionOfDocumemts: this.commonSealForm.controls.descriptionOfDocumemts.value,
      dateOfResolutionauthorisingtheuseofcommonseal: this.setDate(this.commonSealForm.controls.dateOfResolutionauthorisingtheuseofcommonseal.value),
      dateOfaffixixngsealonthedocument: this.setDate(this.commonSealForm.controls.dateOfaffixixngsealonthedocument.value),
      nameOfPerson: this.commonSealForm.controls.nameOfPerson.value,
      depositReceiptNumber: this.commonSealForm.controls.depositReceiptNumber.value,
      place: this.commonSealForm.controls.place.value,
      remarks: this.commonSealForm.controls.remarks.value,
    }

    this.commonSeal.addCommonSealData(commonSealObject).subscribe(response => {
      this.disabledOnclick = false;
      if (response.status == 0) {
        this.alert.successWithOk(response.message, 'documentundercommonseallist');
      } else {
       
        if(response.err_fields){ 
        this.alert.error( JSON.stringify(response.err_fields) + ' fields are required or invalid.');
        }
        else{
         this.alert.error(response.message);
        }
      }
    })
  }
  updateCommonSeal(_id) {
    this.disabledOnclick = true;
    var object = {
      descriptionOfDocumemts: this.commonSealForm.controls.descriptionOfDocumemts.value,
      nameOfPerson: this.commonSealForm.controls.nameOfPerson.value,
      depositReceiptNumber: this.commonSealForm.controls.depositReceiptNumber.value,
      place: this.commonSealForm.controls.place.value,
      remarks: this.commonSealForm.controls.remarks.value,
      dateOfResolutionauthorisingtheuseofcommonseal: this.setDate(this.commonSealForm.controls.dateOfResolutionauthorisingtheuseofcommonseal.value),
      dateOfaffixixngsealonthedocument: this.setDate(this.commonSealForm.controls.dateOfaffixixngsealonthedocument.value)
    }

    this.commonSeal.updateCommonSealDetail(object, this.editsealId).subscribe(response => {
      this.disabledOnclick = false;
      if (response.status == 0) {
        this.alert.successWithOk(response.message, 'documentundercommonseallist')
      } else {
        // this.alert.error(response.message);
        // this.alert.error( JSON.stringify(response.err_fields) + '  fields are required or invalid.');
        if(response.err_fields){ 
          this.alert.error( JSON.stringify(response.err_fields) + ' fields are required or invalid.');
          }
          else{
           this.alert.error(response.message);
          }
        
      }

    })
  }

  generateOutput() {
    var object = {
      id: this.editsealId,
      fromDate: null,
      toDate: null,
      name: null,
      date1: null
    }
    this.commonSeal.generateCommonSealDocument(object).subscribe(response => {
      if (response.status == 0) {
        this.alert.success(response.message);
        var self = this;
        setTimeout(function () {
          self.downloadDocument(self.editsealId);
          setTimeout(function () {
            self.downloadPdfDocument(self.editsealId);
          }, 1000);
        }, 1000);
      } else {
        this.alert.error(response.message);
      }
    })
  }

  downloadDocument(id) {
    this.commonSeal.downloadCommonSealFile(id, 'Single');
  }
  downloadPdfDocument(id) {
    this.commonSeal.downloadCommonSealPdfFile(id, 'Single');
  }
}
